import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {ErrorAlert, TextField, useFlag} from "@variocube/app-ui";
import {useMutation} from "@tanstack/react-query";
import React, {useState} from "react";
import {useSubscriptionApi} from "../../api/subscription";
import {useLocalization} from "@smalox/shared";

interface SubscriptionCancelProps {
	subscriptionId: number;
	onCancelled: () => void;
}

export function SubscriptionCancel({subscriptionId, onCancelled}: SubscriptionCancelProps) {
	const {t} = useLocalization();
	const {cancelSubscription} = useSubscriptionApi();
	const [open, setOpen, clearOpen] = useFlag(false);
	const [endDate, setEndDate] = useState<string>(new Date().toISOString().split("T")[0]);

	const mutation = useMutation({
		mutationFn: () => cancelSubscription(subscriptionId, {endDate}),
		onSuccess: () => {
			clearOpen();
			onCancelled();
		},
	});

	return (
		<>
			<Button size="small" color="warning" onClick={setOpen}>
				{t("subscriptions.cancel.title")}
			</Button>
			<Dialog open={open} onClose={clearOpen}>
				<DialogTitle>{t("subscriptions.cancel.title")}</DialogTitle>
				<DialogContent>
					<TextField
						label={t("subscriptions.endDate")}
						type="date"
						value={endDate}
						onChange={setEndDate}
						fullWidth
						sx={{mt: 1}}
					/>
					{mutation.error && <ErrorAlert error={mutation.error} />}
				</DialogContent>
				<DialogActions>
					<Button onClick={clearOpen}>{t("cancel")}</Button>
					<Button onClick={() => mutation.mutate()} color="warning" variant="contained" disabled={mutation.isLoading}>
						{t("subscriptions.cancel.confirm")}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}
